import { memo } from 'react';
import styled from '@emotion/styled';

import { Item, ItemDescription } from './BusinessItem';
import { H4 } from './HeadlineItem';

import type { ThemeProps } from '@emotion/react';
import type { CSSObject } from '@emotion/styled';

import type { Wws_QuestionItem } from '../../types/graphql';

const QuestionFlourish = styled("div")`
  ${({ theme }: ThemeProps): CSSObject | undefined =>
    theme.components.QuestionFlourish}
`;

interface QuestionItemProps {
  item: Wws_QuestionItem;
  className?: string | undefined;
}

function QuestionItem({ item, className }: QuestionItemProps) {
  const { id, question, answer } = item;

  return (
    <Item className={className} data-testid={`question-item-${id}`}>
      <QuestionFlourish />

      <H4>{question}</H4>

      <ItemDescription>{answer}</ItemDescription>
    </Item>
  );
}

export default memo(QuestionItem);
